import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { PermissionEnum } from '@interfaces';

type CrHeaderHeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

function coerceHeadingLevel(value: unknown): CrHeaderHeadingLevel | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsedValue = Number(value);

  if (!Number.isInteger(parsedValue) || parsedValue < 1 || parsedValue > 6) {
    return null;
  }

  return parsedValue as CrHeaderHeadingLevel;
}

@Component({
  selector: 'app-cr-header',
  templateUrl: './cr-header.component.html',
  styleUrls: ['./cr-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CrHeaderComponent implements OnInit, OnChanges {
  @Input() isLoading = false;
  @Input() isDisabled = false;

  @Input({ transform: coerceHeadingLevel }) headingLevel: CrHeaderHeadingLevel | null = null;

  @Input() fontSize?: 'LARGE' | 'MEDIUM' | 'SMALL' = 'SMALL';
  @Input() showBorder?: boolean = true;

  @Input() innerHTML?: string;

  @Input() buttonText?: string;
  @Input() buttonRequiredPermissions?: PermissionEnum[] = [];
  @Input() buttonRouterLink?: any[] = [];
  @Input() buttonGoBack? = false;

  @Output() clicked = new EventEmitter<void>();

  public cssClasses: string[] = [];

  public ngOnInit(): void {
    this.updateCssClasses();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['fontSize']) {
      this.updateCssClasses();
    }
  }

  private updateCssClasses(): void {
    this.cssClasses = [`FONT-${this.fontSize}`];
  }

  public onClick(): void {
    if (this.isLoading) {
      return;
    }
    if (this.isDisabled) {
      return;
    }

    this.clicked.emit();
  }
}
